module.exports = __webpack_public_path__ + "static/media/Arial-01.b5c0345c.svg";